exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-header[data-v-223a3f60] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.search-form[data-v-223a3f60] {\n    margin-bottom: 20px;\n}\n.pagination[data-v-223a3f60] {\n    margin-top: 20px;\n    text-align: right;\n}\n.dialog-footer[data-v-223a3f60] {\n    text-align: right;\n}\n", ""]);

// exports
